




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrPatientDetailHeader extends Vue {
  @Prop()
  private patient: any;
  private goBack() {
    this.$router.push({
      path: "/main/sjzx/zbsjk-list",
      query: {
        name: "治未病数据中心",
        type: "治未病数据中心",
        project_id: "治未病数据中心",
      },
    });
  }
}
